module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ui":{"components":{"base":{"search_bar":{"query_too_long_hint":"Enter less characters to display search results."}}}}}}')
  delete Component.options._Ctor
}
